import React from 'react';
import './styles.css';

const Hobbies = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Hobbies component');
    }

    const scrollToEducation = () => {
        const educationSection = document.getElementById('education-section');
        if (educationSection) {
            educationSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Flat list of hobbies with no categories
    const hobbies = [
        { name: "Formula 1", icon: "🏎️", tagline: "Going in circles at 200mph and calling it a sport" },
        { name: "Aviation", icon: "✈️", tagline: "Defying gravity because walking is too mainstream" },
        { name: "Watching Fireship (on 2x)", icon: "🔥", tagline: "Learning things I'll never use at incomprehensible speeds" },
        { name: "Video gaming", icon: "🎮", tagline: "My fictional characters have better life stories than I do" },
        { name: "Documentaries", icon: "🎬", tagline: "Pretending I'm intellectual while eating nachos in pajamas" },
        { name: "Writing parody songs", icon: "🎤", tagline: "Butchering classics one misplaced rhyme at a time" }
    ];


    return (
        <div className="mainArea transition-effect" id="hobbies-section">
            <div className="hobbies transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/aboutMe/f1.png"
                        alt="Hobbies Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Hobbies
                            </div>

                            <img
                                src="/images/siteElements/scroll-up.png"
                                alt="Scroll Up Indicator"
                                className="hobbyScrollUp"
                                onClick={scrollToEducation}
                            />
                        </div>
                        <div className="rightContent">
                            <div className="hobbyList">
                                {hobbies.map(hobby => (
                                    <div key={hobby.name} className="hobbyItem">
                                        <div className="hobbyIcon">
                                            {hobby.icon}
                                        </div>
                                        <div className="hobbyTextContainer">
                                            <span className="hobbyName">{hobby.name}</span>
                                            <span className="hobbyTagline">{hobby.tagline}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/aboutMe/aviation.png"
                        alt="Hobbies Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Hobbies;